interface LineItemNumberParams {
  index: number;
  isRequired: boolean;
  isSupplier: boolean;
  lotNumber: number;
  pageNumber: number;
  pageSize: number;
}

// Generate the `No.` in the format "lotNumber.lineItemIndex"
export const lineItemNumber = ({ index, isRequired, isSupplier, lotNumber, pageNumber, pageSize }: LineItemNumberParams) => {
  const lineItemNo = `${lotNumber + 1}.${((pageNumber - 1) * pageSize) + index + 1}`;
  if (isRequired && isSupplier) {
    return `${lineItemNo} *`;
  }

  return lineItemNo;
};
